import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLanguage } from "../store/reducers/language-reducer";

/**
 * Đổi ngôn ngữ hiển thị: lưu localStorage (axios đọc cho Accept-Language),
 * cập nhật Redux và i18n. Dùng chung cho Login và Sidebar.
 */
export const useChangeLanguage = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  return useCallback(
    (languageCode: string) => {
      if (!languageCode) return;
      localStorage.setItem("language", languageCode);
      dispatch((setLanguage as any)(languageCode));
      i18n.changeLanguage(languageCode);
    },
    [dispatch, i18n]
  );
};
